import {getFunctions, httpsCallable} from "firebase/functions";
import {app} from "../firebase";
// ===============================
// AuthPage.js
// Login + Signup
// Hotel-Wise Loyalty + Spin Points Ready
// ===============================

import React, { useState } from "react";
import "../Auth.css";

import { auth, db } from "../firebase";

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  deleteUser,
} from "firebase/auth";

import {
  doc,
  runTransaction,
  getDoc,
  serverTimestamp,
} from "firebase/firestore";

import { setSignupProvisioning } from "../services/signupProvisioning";
import { useNavigate } from "react-router-dom";

function AuthPage() {
  const [isSignup, setIsSignup] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    password: "",
    referralPhone: "",
  });

  const navigate = useNavigate();

  const OWNER_REFERRAL_PHONE = "8810663507";

  // ===============================
  // INPUT CHANGE
  // ===============================

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((previousData) => ({
      ...previousData,
      [name]: value,
    }));
  };

  // ===============================
  // PHONE CLEANER
  // ===============================

  const cleanPhoneNumber = (phone) => {
    return String(phone || "")
      .replace(/\D/g, "")
      .trim();
  };

  // ===============================
  // LOGIN
  // ===============================

  const handleLogin = async (event) => {
    event.preventDefault();

    if (submitting) return;

    const email = formData.email.trim();
    const password = formData.password;

    if (!email) {
      return alert("Email required.");
    }

    if (!password) {
      return alert("Password required.");
    }

    setSubmitting(true);

    try {
      await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      navigate("/main", {
        replace: true,
      });
    } catch (error) {
      console.error("Login error:", error);

      let message =
        error?.message || "Login failed.";

      if (
        error?.code ===
        "auth/invalid-credential"
      ) {
        message =
          "Email ya password galat hai.";
      } else if (
        error?.code ===
        "auth/user-not-found"
      ) {
        message =
          "Is email se koi account nahi mila.";
      } else if (
        error?.code ===
        "auth/wrong-password"
      ) {
        message =
          "Password galat hai.";
      } else if (
        error?.code ===
        "auth/too-many-requests"
      ) {
        message =
          "Bahut baar wrong login attempt hua hai. Thodi der baad try karo.";
      }

      alert(message);
    } finally {
      setSubmitting(false);
    }
  };

  // ===============================
  // SIGNUP
  // ===============================

  const handleSignup = async (event) => {
    event.preventDefault();

    if (submitting) return;

    const name =
      formData.name.trim();

    const phone =
      cleanPhoneNumber(
        formData.phoneNumber
      );

    const email =
      formData.email
        .trim()
        .toLowerCase();

    const password =
      formData.password;

    const referralPhone =
      cleanPhoneNumber(
        formData.referralPhone
      );

    // ===============================
    // VALIDATION
    // ===============================

    if (!name) {
      return alert("Name required.");
    }

    if (!phone) {
      return alert(
        "Phone number required."
      );
    }

    if (phone.length !== 10) {
      return alert(
        "Please enter valid 10 digit phone number."
      );
    }

    if (!email) {
      return alert("Email required.");
    }

    if (!password) {
      return alert(
        "Password required."
      );
    }

    if (password.length < 6) {
      return alert(
        "Password minimum 6 characters ka hona chahiye."
      );
    }

    if (
      referralPhone &&
      referralPhone.length !== 10
    ) {
      return alert(
        "Referral number valid 10 digit hona chahiye."
      );
    }

    if (
      referralPhone &&
      referralPhone === phone
    ) {
      return alert(
        "Aap apna khud ka number referral me use nahi kar sakte."
      );
    }

    setSubmitting(true);

    let newAccount = null;
    let profileCommitted = false;
    try {
      setSignupProvisioning(true);
      let account = auth.currentUser;
      if (!account || account.email?.toLowerCase() !== email) {
        try {
          const credential = await createUserWithEmailAndPassword(auth, email, password);
          account = credential.user;
          newAccount = account;
        } catch (error) {
          if (error.code !== 'auth/email-already-in-use') throw error;
          account = (await signInWithEmailAndPassword(auth, email, password)).user;
        }
      }
      sessionStorage.setItem(`pendingSignup_${account.uid}`, JSON.stringify({name, phoneNumber: phone, referralPhone}));
      const response = await httpsCallable(getFunctions(app, 'asia-south1'), 'completeCustomerSignup')({name, phoneNumber: phone, referralPhone});
      const signupSpinPoints = Number(response.data.spinPoints || 0);
      profileCommitted = true;
      sessionStorage.removeItem(`pendingSignup_${account.uid}`);

      if (
        signupSpinPoints === 2
      ) {
        alert(
          "Signup successful! ✅\n\nAapko 2 Spin Points mile hain."
        );
      } else if (
        signupSpinPoints === 1
      ) {
        alert(
          "Signup successful! ✅\n\nAapko 1 Spin Point mila hai."
        );
      } else {
        alert(
          "Signup successful! ✅"
        );
      }

      navigate("/main", {
        replace: true,
      });
    } catch (error) {
      if (newAccount && !profileCommitted && ["functions/already-exists", "functions/invalid-argument", "functions/failed-precondition", "functions/permission-denied"].includes(error?.code)) {
        try { await deleteUser(newAccount); } catch (rollbackError) { console.warn('Unprovisioned account cleanup failed:', rollbackError.code); }
      }
      console.error(
        "Signup error:",
        error
      );

      let message =
        error?.message ||
        "Signup failed.";

      if (
        error?.code ===
        "auth/email-already-in-use"
      ) {
        message =
          "This email is already registered.";
      } else if (
        error?.code ===
        "auth/invalid-email"
      ) {
        message =
          "Please enter a valid email.";
      } else if (
        error?.code ===
        "auth/weak-password"
      ) {
        message =
          "Password weak hai. Minimum 6 characters use karo.";
      } else if (
        error?.code ===
        "auth/network-request-failed"
      ) {
        message =
          "Internet connection check karo.";
      } else if (
        error?.code ===
        "permission-denied"
      ) {
        message =
          "Firestore permission error. Rules check karo.";
      }

      alert(message);
    } finally {
      setSignupProvisioning(false);
      setSubmitting(false);
    }
  };

  // ===============================
  // UI
  // ===============================

  return (
    <div className="auth-bg">
      <div className="wrapper">

        {/* ===============================
            LOGO
        =============================== */}

        <div className="auth-logo">
          <img
            src="/images/el-logo.png"
            alt="Hotel Dev Palace"
          />

          <p>
            Welcome to Hotel Dev Palace
          </p>
        </div>

        {/* ===============================
            LOGIN / SIGNUP TOGGLE
        =============================== */}

        <div className="slide-controls">
          <label
            className={`slide login ${
              !isSignup
                ? "active"
                : ""
            }`}
            onClick={() => {
              if (submitting) return;

              setIsSignup(false);
            }}
          >
            Login
          </label>

          <label
            className={`slide signup ${
              isSignup
                ? "active"
                : ""
            }`}
            onClick={() => {
              if (submitting) return;

              setIsSignup(true);
            }}
          >
            Signup
          </label>
        </div>

        {/* ===============================
            FORM CONTAINER
        =============================== */}

        <div className="form-container">
          {!isSignup ? (

            // ===============================
            // LOGIN FORM
            // ===============================

            <form
              onSubmit={handleLogin}
              className="login"
            >
              <div className="field">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={
                    formData.email
                  }
                  onChange={
                    handleChange
                  }
                  autoComplete="email"
                  required
                />
              </div>

              <div className="field">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={
                    formData.password
                  }
                  onChange={
                    handleChange
                  }
                  autoComplete="current-password"
                  required
                />
              </div>

              <div className="field btn">
                <input
                  type="submit"
                  value={
                    submitting
                      ? "Logging In..."
                      : "Login"
                  }
                  disabled={submitting}
                  style={{
                    opacity:
                      submitting
                        ? 0.7
                        : 1,

                    cursor:
                      submitting
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </div>

              <div className="forget-link">
                <a
                  href="/forgot-password"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Forgot Password?
                </a>
              </div>
            </form>
          ) : (

            // ===============================
            // SIGNUP FORM
            // ===============================

            <form
              onSubmit={handleSignup}
              className="signup"
            >
              <div className="field">
                <input
                  type="text"
                  name="name"
                  placeholder="Full Name"
                  value={
                    formData.name
                  }
                  onChange={
                    handleChange
                  }
                  autoComplete="name"
                  required
                />
              </div>

              <div className="field">
                <input
                  type="tel"
                  name="phoneNumber"
                  placeholder="Phone Number"
                  value={
                    formData.phoneNumber
                  }
                  onChange={(event) => {
                    const value =
                      event.target.value.replace(
                        /\D/g,
                        ""
                      );

                    setFormData(
                      (previousData) => ({
                        ...previousData,

                        phoneNumber:
                          value.slice(
                            0,
                            10
                          ),
                      })
                    );
                  }}
                  inputMode="numeric"
                  maxLength={10}
                  autoComplete="tel"
                  required
                />
              </div>

              <div className="field">
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={
                    formData.email
                  }
                  onChange={
                    handleChange
                  }
                  autoComplete="email"
                  required
                />
              </div>

              <div className="field">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={
                    formData.password
                  }
                  onChange={
                    handleChange
                  }
                  autoComplete="new-password"
                  minLength={6}
                  required
                />
              </div>

              <div className="field">
                <input
                  type="tel"
                  name="referralPhone"
                  placeholder="Referral No (optional)"
                  value={
                    formData.referralPhone
                  }
                  onChange={(event) => {
                    const value =
                      event.target.value.replace(
                        /\D/g,
                        ""
                      );

                    setFormData(
                      (previousData) => ({
                        ...previousData,

                        referralPhone:
                          value.slice(
                            0,
                            10
                          ),
                      })
                    );
                  }}
                  inputMode="numeric"
                  maxLength={10}
                />
              </div>

              <div className="field btn">
                <input
                  type="submit"
                  value={
                    submitting
                      ? "Creating Account..."
                      : "Signup"
                  }
                  disabled={submitting}
                  style={{
                    opacity:
                      submitting
                        ? 0.7
                        : 1,

                    cursor:
                      submitting
                        ? "not-allowed"
                        : "pointer",
                  }}
                />
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AuthPage;